<template>
	<div class="fatness">
		<Loading msg="loading" v-if="!isload" />
		<div class="fatness_inner" v-else>
          	<img @click="$parent.goBack()"
				v-lazy="'https://static.inertiabiotech.com/uniskin/reportv3/images/gene_test_back.png'"
				class="back_btn lazy"
				alt="" />
                <img src="../assets/images/fatness_head_pic.png" class="fatness_head_pic" alt="">
                <div class="fatness_inner_info">
                <h1 class="fatness_title">你是喝水都容易胖的人吗?</h1>
               
                <p class="fatness_dialog">当你的朋友说<br>“我要减肥了,太胖了.” </p>
                <p class="fatness_dialog">然后你嗤之以鼻<br>“你上个月就这么说的.”</p>
                <p class="fatness_dialog">她紧跟着哀怨的看着你<br>“我最近一直在节食.”</p>
                <p class="fatness_dialog">你震惊<br>“但是我看你没啥变化啊,就是憔悴了点……“</p>
                <p class="fatness_dialog">最后她咆哮<br>“因为劳资喝水都能胖啊啊啊!”</p>
                <p class="fatness_dialog_sub">日常生活中,节食减肥的人大有人在,个人觉得有一部分人节食减肥纯粹是因为懒得动!但是节食真的能瘦吗?我只能说:因人而异!<br>你是否真的有节食就能瘦的美好“优点”,到底还是要看基因给不给你这个特权!</p>

                <div class="fatness_gene_result">
                    <div class="gene_result_title">您的基因结果显示</div>
                    <div class="gene_result_sub_title"><span>基因:APOA5</span><span>位点:rs662799</span></div>
                    <ul class="gene_result_info">
                        <li class="info_item info_title"><span class="item_name">基因型</span><span class="item_result">检测结果</span></li>
                        <li class="info_item" :class="((fatness_result.indexOf('GG') > -1) || (fatness_result.indexOf('AG') > -1) || (fatness_result.indexOf('GA') > -1)) ? 'now' : ''"><span class="item_name">GA/GG</span><span class="item_result">低脂饮食能瘦</span></li>
                        <li class="info_item" :class="fatness_result == 'AA' ? 'now' : ''"><span class="item_name">AA</span><span class="item_result">低脂饮食不能瘦</span></li>
                       
                    </ul>

                </div>

                <div class="fatness_2nd_title">基因详情</div>
                <p class="fatness_2nd_text">所以你不吃东西能不能瘦下来,归根结底还是要靠这个名为APOA5的基因.这个基因能够编码一种载脂蛋白,并且参与甘油三脂的代谢和脂蛋白的分解代谢. </p>
                <p class="fatness_2nd_text">在APOA5基因的某一个名为rs662799位点上,它对饮食影响体重有着非常显著的相关性.该位点上携带G等位基因的人在接受低脂饮食一段时间之后能够有明显的体重减少的变化,而当他们如果偏好高脂饮食反而并不容易长胖! 这就是传说中的“吃垮都不胖”的体质.</p>
                <p class="fatness_2nd_text">而另一方面,AA基因型的人就不一样了,不仅低脂饮食不能瘦,如果长期摄入高脂食物,这类人的体重就会直线上升.由此可见,AA基因型的人一旦不注意脂肪食物的摄入，比如炸鸡、奶油蛋糕、巧克力等，那就等着嗖嗖嗖发胖吧!</p>
                <p class="fatness_2nd_text">而那些携带GA/GG基因型的人,如果你想减肥但是又懒得动,那就把“油脂”戒掉吧,过一段日子你就能瘦成一条闪电!</p>
                
                <div class="fatness_share_tip">长按图片分享</div>
                <v-touch v-on:pressup="$parent.trackLog((actParams = { query: $route.query, pageid: 470 }),{is_access:true,reportEvent_page_id:'470',reportEvent_page_name:'你是喝水都容易胖的人吗-分享图',reportEvent_report_type:'199基因',reportEvent_first_module:'基因有讲究',reportEvent_second_module:'分享'});">
                <img :src="fatness_img" :key="fatness_img" class="fatness_share_pic" alt="">
                </v-touch>
   
            </div>
        </div>
	</div>
</template>

<script>
import Loading from "./Loading.vue";
import axios from "axios";

export default {
  name: "Fatness",
  data() {
    return {
      isload: false,
      fatness_result:'',
      fatness_img:''
    };
  },

  created() {
    console.log("fatness created", this);
    this.initFatness();
  },
  mounted() {
    //判断内容是否少于一屏
    let window_h = window.innerHeight;
    let body_h = document.querySelector("body").offsetHeight;
    if (body_h <= window_h) {
      document.querySelector("body").style.height = window_h + "px";
      document.querySelector("body").style.backgroundColor = "#f9f8f8";
    }
  },
  methods: {
    //初始化 桃花指数
    initFatness: function() {
      let that = this;
      var local_fatness = JSON.parse(localStorage.getItem("local_fatness"));
      if (local_fatness) {
        after_fatness(local_fatness);
      } else {
        that
          .$jsonp(
            "https://www.uniskin.com.cn/reportv2/index/Gene_Share_Img/get199Type1004"
          )
          .then(json => {
            console.log("fatness", json);
            // localStorage.setItem("local_fatness",JSON.stringify(json));
            after_fatness(json);
          })
          .catch(err => {
            // Failed.
            localStorage.clear();
            location.href =
              "https://www.uniskin.com.cn/mall/member/account/login";
          });
      }
      function after_fatness(fatness_data) {
        console.log("fatnessdata", fatness_data);
        if (fatness_data.code == 0) {
            that.fatness_result = fatness_data.data.genotype;
            that.fatness_img = fatness_data.data.img;
          that.isload = true;
        }
      }
    },

    markpopupBtn: function() {
      this.markpopup.show = false;
      let _status = this.total_data.data.targetquestions.tag;
      if (_status == 1) {
        this.$router.push("/article/explainoth");
      } else if (_status == 2) {
        this.$router.push("/article/explain");
      }
    },
    initActionLog: function(m, pageid) {
      if (m && pageid)
        return axios.get("/mall/member/reportV2/actionlog", {
          params: { m, pageid }
        });
    }
  },
  components: {
    Loading
  }
};
</script>
<style lang="less" scoped>
@import "../styles/mixin.less";
@import "../styles/reset.less";
.back_btn {
  position: fixed;
  top: 30/50rem;
  left: 0;
  z-index: 99999;
  width: 118/50rem;
  height: 54/50rem;
}
.report_page {
  box-sizing: border-box;
  position: relative;
}
.report_page {
  background: @bg_c_m;
}
.fatness_head_pic{
    width:100%;
}
.fatness_inner{
    padding:0 0 202/50rem;
    .fatness_inner_info{
        padding:0 30/50rem;
    }
    .fatness_title{
    position:relative;
    padding:46/50rem 0 72/50rem;
    margin-bottom:50/50rem;
    font-size:44/50rem;
    line-height:1em;
    font-weight:bold;
    color:@font-c-0;
    &::after{
        content:'';
        display:block;
        position:absolute;
        left:0;
        bottom:0;
        width:136/50rem;
        height:3/50rem;
        background:@font-c-detail;
    }
    }

    .fatness_dialog{
        padding-bottom:20/50rem;
        font-size:28/50rem;
        line-height:36/50rem;
        color:@font-c-6;
       
    }
    .fatness_dialog_sub{
        padding-bottom:54/50rem;
        font-size:28/50rem;
        line-height:36/50rem;
        color:@font-c-3;
    }
}
.fatness_gene_result{
    padding-bottom:30/50rem;
    .gene_result_title{
        font-size:34/50rem;
        line-height:1em;
        color:@font-c-detail;
        font-weight:bold;
        text-align:center;
    }
    .gene_result_sub_title{
        padding:26/50rem 0 19/50rem;
        .display_flex;
        .flex-wrap_nowrap;
        .justify-content_flex-start;
        span{
            .flex_0;
            .align-items_center;
            font-size:28/50rem;
            line-height:1em;
            color:@font-c-3;
            padding-right:39/50rem;
        }
    }
}
.gene_result_info{
    background:@bg_c_l;
    box-sizing:border-box;
    padding:46/50rem 30/50rem 25/50rem;
    .shadow();
    .border-radius(14/50rem);
    .info_item{
        &.now::after{
            .flex_0;
            .align-items_center;
            content:"";
            display:block;
            width:35/50rem;
            height:20/50rem;
            background:url('../assets/images/check_icon_light.png') no-repeat 0 0;
            background-size:contain;
        }
        &.now{
            color:@font-c-detail;
        }
        padding-bottom:30/50rem;
        .display_flex;
        .flex-wrap_nowrap;
        .justify-content_flex-start;
        font-size:30/50rem;
        line-height:1em;
        color:@font-c-3;
        .item_name{
            .flex_0;
            .align-items_center;
            box-sizing:border-box;
            width:53%;
            padding-left:100/50rem;
        }
        .item_result{
            .flex_0;
            .align-items_center;
            box-sizing:border-box;
            // width:47%;
            padding-right:20/50rem;
        }
    }
    .info_title{
        font-weight:bold;
        border-bottom:2/50rem solid @font-c-detail;
        padding-bottom:13/50rem!important;
        margin-bottom:30/50rem;
    }
}
.fatness_2nd_title{
    position:relative;
    padding-left:22/50rem;
    margin-top:70/50rem;
    margin-bottom:20/50rem;
    font-size:34/50rem;
    line-height:1em;
    font-weight:bold;
    color:@font-c-3;
    &::before{
        content:"";
        display:block;
        position:absolute;
        left:0;
        top:50%;
        -webkit-transform:translateY(-50%);
        transform:translateY(-50%);
        width:6/50rem;
        height:22/50rem;
        background:@font-c-detail;
    }
}
.fatness_2nd_text{
    padding:0 0 40/50rem;
    font-size:28/50rem;
    line-height:38/50rem;
    color:@font-c-3;
}
.fatness_down_pic{
    width:100%;
}
.fatness_share_tip{
    padding:40/50rem 0 24/50rem;
    text-align:right;
    font-size:28/50rem;
    line-height:1em;
    color:@font-c-3;
}
.fatness_share_pic{
    width:100%;
    .shadow();
    .border-radius(14/50rem);
}

</style>
